import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import {
  fetchDataEngine,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import {
  AllPayrollQuery,
  employeeLeaveBalances,
} from "../../../data/Queries/HRmanagement/leavemanagement";
import { HRService } from "../../../config";
import { tokens } from "../../../theme";
import { useTheme } from "@emotion/react";
import { PayrollColumns } from "../../../data/Columns/hrmanagement";
import PayrollCreationForm from "./form";


const base_url = HRService.uri;

const PayrollTable = () => {
  const actions = {
    entity: "Payroll",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
      inputObjectName: "createCaseDynamic",
      InputObject: "newCase",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },
    AssignTask: {
      key: "ASSIGN_TASK",
      button_name: "Assign Task",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    ViewPayrollLines: {
      key: "VIEWPAYROLLLINES",
      button_name: "View Lines",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },

     // ---------- APPROVE ----------
  RUNPAYROLL: {
    key: "RunPayroll",
    button_name: "Calculate payrollrun",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  sendForapprovalPayrollRun: {
      key: "SENDFORAPPROVAL",
      button_name: "Sent For Approval",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },

  // POSTPAYROLL: {
  //   key: "PostPayroll",
  //   button_name: "Post To GL",
  //   Show_Button: true,
  //   permission: "hasNoPermission",
  //   roleGroupId: [1, 2, 3, 4],
  // },
  

    showStatus: true,
  };
  const [data, setData] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  useEffect(() => {
    let isMounted = true;

    async function fetchLeaveBalances() {
      try {
        const response = await graphqlQuery(employeeLeaveBalances, base_url);
        if (response) {
          setData(response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchLeaveBalances();

    return () => {
      isMounted = false;
    };
  }, []);
 
  return (
    <Box m="2px">
      <>
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          
        </Box>
        <DynamicTable
          title="Payroll"
          subtitle="View all Payroll, create or update a employee"
          columns={PayrollColumns}
          FormComponent={PayrollCreationForm}
          query={AllPayrollQuery}
          actions={actions}
          base_url={base_url}
        />
      </>
    </Box>
  );
};

export default PayrollTable;
